import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <>
      <p>
        Dox and Box (“Company”, “we”, “our”, or “us”) is committed to protecting your privacy and ensuring the security of your personal and business information. This Privacy Policy explains how we collect, use, store, protect data when you access our website, platform, services. By using our services, you agree to the practices described in this Privacy Policy.
      </p>

      <h3 className="heading">Information We Collect</h3>
      <p>
        We may collect different types of information depending on your interaction with our platform. This includes personal information such as your name, email address, phone number, company name, designation, billing or payment details. We also collect business and document data, including files, documents, records uploaded to the platform, any associated metadata. In addition, we may collect technical information such as your IP address, browser type, device information, usage data, log files, how you interact with our platform.

      </p>

      <h3 className="heading">How We Use Your Information</h3>
      <p>
        We use the information we collect to provide and manage our services, enable secure document storage and access, improve platform functionality and user experience. Your information may also be used to communicate with you regarding services, updates, support, as well as to ensure compliance with legal and regulatory obligations. We do not sell your personal or business data to third parties.

      </p>

      <h3 className="heading">Data Ownership</h3>
      <p>
        Users retain full ownership of all documents and data uploaded to the platform. Dox and Box acts strictly as a data processor and uses the data only to the extent necessary to deliver its services.

      </p>

      <h3 className="heading">Data Sharing and Disclosure</h3>
      <p>
        We may share your information only in limited circumstances, such as with authorized service providers who assist in delivering our services, when required by law, regulation, or legal process, or to protect rights, security, prevent fraud. All third-party partners are required to adhere to strict confidentiality and data protection standards.

      </p>

      <h3 className="heading">Data Security</h3>
      <p>
        We implement industry-standard security measures to safeguard your data, including encryption both in transit and at rest, role-based access controls, secure cloud infrastructure with backups, monitoring systems with audit trails. While we take all reasonable precautions, no system can guarantee absolute security.
      </p>

      <h3 className="heading">Data Retention</h3>
      <p>
        We retain your data only for as long as necessary to provide our services, comply with legal and regulatory requirements, resolve disputes, enforce agreements. Users may request deletion of their data, subject to any contractual or legal obligations that may require retention.
      </p>

      <h3 className="heading">Your Rights</h3>
      <p>
        In accordance with applicable laws, including the Digital Personal Data Protection Act, 2023 (India), you have rights over your personal data. These include the ability to access your data, request corrections or updates, request deletion, withdraw consent where applicable. You may exercise these rights using the contact details provided below.
      </p>

      <h3 className="heading">Cookies and Tracking Technologies</h3>
      <p>
        Our website may use cookies and similar tracking technologies to enhance user experience, analyze website performance, remember user preferences. You can control or manage cookie settings through your browser configuration.
      </p>

      <h3 className="heading">Third-Party Services</h3>
      <p>
        Our platform may integrate with third-party services such as CRM or ERP tools. We are not responsible for the privacy practices or policies of these third parties, users are encouraged to review their respective privacy policies before using such integrations.
      </p>

      <h3 className="heading">Cross-Border Data Transfers</h3>
      <p>
        Where necessary, your data may be processed or stored in locations outside your primary jurisdiction. In such cases, we ensure that appropriate safeguards are in place and that all transfers comply with applicable data protection laws.
      </p>

      <h3 className="heading">Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page along with an updated effective date. Continued use of our services after such updates constitutes your acceptance of the revised policy.
      </p>

      <h3 className="heading">Contact Us</h3>
      <p>For any questions, concerns, or requests related to this Privacy Policy, please contact:
      </p>
      <p>Email: <Link to={"mailto:info@doxandbox.com"}>info@doxandbox.com</Link>
        <br />
        Phone: <Link to={"tel:+91-9580374374"}>+91-9580374374</Link></p>

    </>
  );
}
